import { render, staticRenderFns } from "./Evidencia.vue?vue&type=template&id=37ca39d8&scoped=true"
import script from "./Evidencia.vue?vue&type=script&lang=js"
export * from "./Evidencia.vue?vue&type=script&lang=js"
import style0 from "./Evidencia.vue?vue&type=style&index=0&id=37ca39d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca39d8",
  null
  
)

export default component.exports